import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SERVICES_CONSTANTS } from '../utils/constants';
import { StringUtils } from '../utils/stringUtils';
import { ApiResponse } from '../model/auth/api-response';
import { HelpRequestDTO } from '../model/help-request-dto';
import { HelpRequestResponseDTO } from '../model/help-request-response-dto';
import { HelpRequestReplyRequestDTO } from '../model/help-request-reply-request-dto';
import { HelpRequestStatusAction, HelpRequestStatusRequestDTO } from '../model/help-request-status-request-dto';

@Injectable({
  providedIn: 'root'
})
export class HelpRequestsService {
  private baseUrl: string = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private stringUtils: StringUtils
  ) {}

  /**
   * Obtener lista paginada de casos de ayuda
   */
  getHelpRequests(page: number = 0, size: number = 10): Observable<ApiResponse<HelpRequestResponseDTO>> {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.HELP_REQUESTS.MAIN
    );

    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    return this.http.get<ApiResponse<HelpRequestResponseDTO>>(url, { params });
  }

  /**
   * Obtener detalles de un caso específico incluyendo archivos
   */
  getHelpRequestById(caseId: string): Observable<ApiResponse<HelpRequestDTO>> {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.HELP_REQUESTS.MAIN,
      `/${caseId}`
    );

    return this.http.get<ApiResponse<HelpRequestDTO>>(url);
  }

  /**
   * Agrega la respuesta del operador a la conversación del caso y notifica al usuario.
   */
  replyToCase(caseId: string, message: string): Observable<ApiResponse<any>> {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.HELP_REQUESTS.MAIN,
      `/${caseId}`,
      SERVICES_CONSTANTS.ADMIN_PATH.HELP_REQUESTS.REPLY
    );

    const body: HelpRequestReplyRequestDTO = { message };
    return this.http.post<ApiResponse<any>>(url, body);
  }

  /**
   * Cierra o reabre un caso de ayuda.
   */
  updateCaseStatus(caseId: string, action: HelpRequestStatusAction): Observable<ApiResponse<any>> {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.HELP_REQUESTS.MAIN,
      `/${caseId}`,
      SERVICES_CONSTANTS.ADMIN_PATH.HELP_REQUESTS.STATUS
    );

    const body: HelpRequestStatusRequestDTO = { action };
    return this.http.patch<ApiResponse<any>>(url, body);
  }
}
